import Background from "./background";

export default Background;
